/**
 * 🔨 Translates the currency type if needed
 * @param rawCurrencyString 
 */
export function resolveCurrency(rawCurrencyString: string): string {
  switch (rawCurrencyString) {
    case "XBT": return "BTC";
    case "EUR": return "EU";
    case "USD": return "US";
    default: return rawCurrencyString;
  }
}

/**
 * 🧠 Possible types of currencies
 */
export enum CurrencyType {
  CryptoCurrency,
  NormalCurrency
}

/**
 * 🔨 Determines the type of currency
 * @param rawCurrencyString
 */
export function resolveCurrencyType(rawCurrencyString: string): CurrencyType {
  switch (rawCurrencyString) {
    case "USD": return CurrencyType.NormalCurrency;
    case "EUR": return CurrencyType.NormalCurrency;
    default: return CurrencyType.CryptoCurrency;
  }
}

/**
 * 🧠 Possible types of cryptocurrencies
 */
export enum CryptocurrencyType {
  STABLE_COINS,
  CRYPTO
}

// 🗻 The available stable coin currencies
const stableCoinCurrencies: string[] = ["EUR", "GBP", "USDT", "BUSD", "USDC", "USD"];

/**
 * 🔨 Determines the type of cryptocurrency
 * @param rawCurrencyString
 */
export function resolveCryptocurrencyType(rawCurrencyString: string): CryptocurrencyType {
  if (stableCoinCurrencies.includes(rawCurrencyString)) {
    return CryptocurrencyType.STABLE_COINS
  }
  return CryptocurrencyType.CRYPTO;
}

/**
 * 🔨 Determines whether a cryptocurrency is stable coin or not
 * @param rawCurrencyString
 */
export function isStableCoinCryptocurrency(rawCurrencyString: string): boolean {
  return stableCoinCurrencies.find((currency: string) => currency === rawCurrencyString) !== undefined;
}
